<template>
    <div>
        <el-carousel :autoplay="autoplay" height="6rem" :indicator-position="picList.length==1?'none':''" :arrow="picList.length==1?'never':''">
            <el-carousel-item v-for="(item,index) in picList" :key="index" >
                <div v-if="item.jumpUrl" @click="goothers(item)" class="cu">
                    <img :src="item.imgUrl" alt="">
                    <!-- <img :src="baseUrl+item.imgUrl" alt=""> -->
                    <slot name="imgTitle"></slot>
                </div>
                <div v-else>
                    <img :src="item.imgUrl" alt="">
                    <!-- <img :src="baseUrl+item.imgUrl" alt=""> -->
                    <slot name="imgTitle"></slot>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
// import * as api_activity_home from 'service/api/methods/api_activity_home.js';
export default {
    props:{
        picList:{
            type:Array,
            default:()=>[]
        },
        // baseUrl:{
        //     type:String,
        //     default:''
        // }
        autoplay:{
            type:Boolean,
            default:false
        }
    },
    methods: {
        goothers(url){
            this.addClickRate({bannerid:url.bannerid});
            window.open(url.jumpUrl,'_blank');
        },
        // addClickRate(p){
        //     api_activity_home.addClickRate(p).then(()=>{

        //     })
        // }
    }
}
</script>
<style lang="less" scoped>
.cu{
    cursor: pointer;
}
/deep/ .el-carousel__button{
    width:6px;
    height: 6px;
    border-radius: 50%;
    overflow: hidden;
}
div{
    // width:100%;
    height: 100%;
}
img{
    width:1980px;
    height: 100%;
}
/deep/ .el-carousel__item{
    text-align:center;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>
